import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Irony",
  "description": "",
  "published": "2006-11-02T00:00:00.000Z",
  "redirect_from": ["/blog/irony/swizec/372"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I managed to embark on a great voyage of distant lands and far reaching shores of the imaginative sea, but why have you only written only 300 words all day then, will you ask. Of course, it figures as a general rule of whatever, there was no time to actually write out all the wonderful inspiration begotten from the heights of above. Whereas yesterday I sat almost all day in front of the computer trying hard to think up words to write, today words were there, waiting, lusting to be written, but no time to actually write them out. In a word, stupidity.`}</p>
    <p>{`Just a quick thought about the trebuchet, it now features a 1.6 kilo weight and almost falls apart each time it is used; the worst thing being that the size of my apartment doesn't permit testing of the maximum range it can achieve, sad, so sad.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      